import React from 'react'

import { Form, Col } from '_zari/core'

import { SelectTituloViatico } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const TituloViaticoFormGroup = ({ vIdSocio, setIdTituloViatico, ocultarSections }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('button-asignarDocs-continuar-1', e)
  }, [])

  const onChange = React.useCallback(
    e => {
      setIdTituloViatico(e.target.value)
      ocultarSections()
    },
    [setIdTituloViatico, ocultarSections]
  )

  return (
    <Form.Group>
      <Form.Label text='SALIDA' htmlFor='select-asignarDocs-tituloViatico' md={4} alignRightAt='md' />
      <Col md={8}>
        <SelectTituloViatico
          disabled={!vIdSocio}
          id='select-asignarDocs-tituloViatico'
          onKeyDown={onKeyDown}
          idSocio={vIdSocio}
          onChange={onChange}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(TituloViaticoFormGroup)
